export default __webpack_public_path__ + "static/media/hk.231f21fd.svg";